import { AI_AGENT_GENERAL_SETTINGS, AI_AGENTS } from '@/composables/useAgentSections'

export default {
  bases: ['/ai'],
  fetches: [],
  build: () => [
    { name: 'Overview', link: AI_AGENTS, exact: [AI_AGENTS] },
    { name: 'General settings', link: AI_AGENT_GENERAL_SETTINGS, exact: [AI_AGENT_GENERAL_SETTINGS] }
  ]
}
